import React from "react";
import { Link } from "react-router-dom";
import "../styles/BlogFile.css";

function Blog2() {
  return (
    <div className="blog-post-container">
      <h2 className="blog-post-title">Blockchain & Medical Data: The Future of Secure Health Records</h2>
      <p className="blog-post-date">April 2025</p>

      <h3 className="blog-post-title">AI & Blockchain: Decision-Support, Not Absolute Diagnosis</h3>
      <p className="blog-post-content">
        AI concussion detection and blockchain-powered medical records provide valuable data,  
        but they are not a substitute for human expertise.  
        The goal is to create a decision-support system that helps trainers, doctors, and emergency responders  
        make more informed choices, not to remove human evaluation from the process.  
      </p>

      <h3 className="blog-post-title">How Blockchain Protects Patient Data</h3>
      <p className="blog-post-content">
        Unlike traditional medical databases, blockchain-based medical records ensure patient data is immutable and accessible only with permission.
        This technology prevents unauthorized tampering and ensures a player's concussion history is accurately preserved.
      </p>

      <h3 className="blog-post-title">Blockchain and HIPAA Compliance: Ensuring Patient Privacy</h3>
      <p className="blog-post-content">
        The Health Insurance Portability and Accountability Act (HIPAA) sets strict guidelines for the storage, sharing, and protection of medical records.
        Traditional electronic health records (EHRs) are often centralized, making them vulnerable to breaches and unauthorized access.
        Blockchain offers a HIPAA-compliant approach to data security by providing decentralized, encrypted, and permission-based access to health records.
      </p>

      <p className="blog-post-content">
        Blockchain-based health records give patients greater control over their data.  
        Instead of relying on hospitals or third-party providers, patients can grant or revoke access to their records instantly. 
        This eliminates unnecessary data sharing and ensures only authorized personnel can view sensitive health information.
      </p>

      <h3 className="blog-post-title">How Blockchain Enhances Medical Privacy</h3>
      <p className="blog-post-content">
        - Tamper-Proof Records: Once recorded, patient data cannot be altered or deleted, reducing the risk of fraud.  
        - Decentralized Access: Data is not stored in a single location, minimizing large-scale data breaches.  
        - Smart Contracts: Patients can set conditions for data access, ensuring their health information is only shared under strict guidelines.  
      </p>

      <p className="blog-post-content">
        As regulations around data privacy tighten, blockchain is becoming a crucial tool for maintaining compliance with HIPAA and other healthcare laws.
        By combining blockchain with AI-powered concussion tracking, players, veterans, and patients gain a higher level of privacy, security, and control over their medical history.
      </p>

      <div className="back-to-blog">
        <Link to="/blog">← Back to Blog</Link>
      </div>
    </div>
  );
}

export default Blog2;